import React from 'react';
import { OfflineBanner } from '../pwa/OfflineBanner';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <>
      <OfflineBanner />
      <header role="banner">
        {/* Navigation is likely handled within pages/components, but semantic structure belongs here if applicable, or left simple */}
      </header>
      <main role="main">
        {children}
      </main>
    </>
  );
}
